export default {
    title: 'Formula 1'
}



// WEBPACK FOOTER //
// src/lang/locales/en/meta.js